module.exports = __webpack_public_path__ + "static/media/img_linea_blanca.e2396c87.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img_linea_blanca.webp
// module id = 198
// module chunks = 1